// @flow
import { connect } from 'react-redux';
import type { State } from '../../../types';
import appActions from '../../../actions/appActions';
import { activeSectionSelector } from '../../../selectors/appSelectors';
import { statusConfigSelector, runwaysSelector } from '../../../selectors/configSelectors';
import { nameSelector } from '../../../selectors/userSelectors';
import { planeCountSelector } from '../../../selectors/planeSelectors';
import Navbar from '../Navbar';
import type { Props } from '../Navbar';

const mapStateToProps = (state: State) => {
    return {
        activeSection: activeSectionSelector(state),
        status: statusConfigSelector(state) || {},
        runways: runwaysSelector(state),
        planeCount: planeCountSelector(state),
        userName: nameSelector(state)
    };
};

const mapDispatchToProps = {
    setActiveSection: appActions.setSection
};

export default connect<Props, *, _, _, _, _>(mapStateToProps, mapDispatchToProps)(Navbar);